package kz.dentalcrm.app.screens.patients.add.mvi

data class AddPatientViewState(
    val isLoading: Boolean = false,
)
